/**
 * Decoración de la franja nocturna: telaraña en la esquina y murciélagos que
 * cruzan despacio. Puramente visual (aria-hidden, pointer-events none) y sin
 * imágenes: SVG inline, así que no suma peticiones.
 *
 * Los murciélagos solo animan `transform`; con prefers-reduced-motion se
 * quedan quietos (ver .night-bat en index.css).
 */
const BAT =
    'M12 4c-1 0-1.6.8-2 1.8C9 4.6 7 3.6 4 4c1 1 1.4 2.2 1.2 3.4C4 7 2.6 7.2 0 8.6c2.4.2 4.2 1 5.4 2.4C6.6 9.6 8 9 9.6 9.4L12 12l2.4-2.6c1.6-.4 3 .2 4.2 1.6 1.2-1.4 3-2.2 5.4-2.4-2.6-1.4-4-1.6-5.2-1.2-.2-1.2.2-2.4 1.2-3.4-3 .4-5 .6-6 2.2C13.6 4.8 13 4 12 4z';

const BATS = [
    { top: '8%', size: 44, dur: 26, delay: 0 },
    { top: '70%', size: 30, dur: 34, delay: -12 },
    { top: '38%', size: 22, dur: 42, delay: -25 },
];

export default function NightDecor() {
    return (
        <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
            {/* Telaraña */}
            <svg viewBox="0 0 100 100" className="absolute -top-px -left-px w-24 md:w-36 h-auto" fill="none" stroke="var(--paper)" strokeOpacity="0.22" strokeWidth="0.8">
                {[0, 18, 36, 54, 72, 90].map((deg) => {
                    const a = (deg * Math.PI) / 180;
                    return <line key={deg} x1="0" y1="0" x2={100 * Math.cos(a)} y2={100 * Math.sin(a)} />;
                })}
                {[22, 40, 60, 82].map((r) => {
                    const pts = [0, 18, 36, 54, 72, 90].map((deg) => {
                        const a = (deg * Math.PI) / 180;
                        return [r * Math.cos(a), r * Math.sin(a)];
                    });
                    // Hilo entre radios con ligera caída, como seda real
                    const d = pts.reduce((acc, [x, y], i) => {
                        if (i === 0) return `M${x},${y}`;
                        const [px, py] = pts[i - 1];
                        return `${acc} Q${(px + x) / 2 - r * 0.06},${(py + y) / 2 - r * 0.06} ${x},${y}`;
                    }, '');
                    return <path key={r} d={d} />;
                })}
            </svg>

            {BATS.map((b, i) => (
                <svg
                    key={i}
                    viewBox="0 0 24 12"
                    className="night-bat absolute left-0"
                    style={{
                        top: b.top,
                        width: b.size,
                        '--bat-dur': `${b.dur}s`,
                        '--bat-delay': `${b.delay}s`,
                    }}
                    fill="var(--paper)"
                    fillOpacity="0.22"
                >
                    <path d={BAT} />
                </svg>
            ))}
        </div>
    );
}
